module.exports = __webpack_public_path__ + "static/media/Editor-Light.4bcda31a.otf";